import { Grid, Hidden, Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import whiteDots from '../../static/images/brain_dots.svg';
import rutaPickup from '../../static/images/Ruta_Pickup_Wide.png';
//import Animation from '../components/Animation';
import { VSpacer } from 'sm-react-components';
import RegisterContainer from '../container/RegisterContainer';
import * as routes from '../../infrastructure/routemap';
import Header from '../components/Header';
import landing01 from '../../static/images/landing_01.svg';
import landing02 from '../../static/images/landing_02.svg';
import landing03 from '../../static/images/landing_03.svg';
import ProductFeature from '../components/ProductFeature';

const styles = theme => ({
    white: {
        color: 'white'
    },
    overHeader: {
        width: '100%',
        height: '600px',
        backgroundColor: '#43494D',
        position: 'absolute',
        top: '0',
        zIndex: '-1',
        overflow: 'hidden',
        textAlign: 'center'
    },
    overHeaderImage: { width: '1100px', marginTop: '-200px', opacity: '0.2' }
});

class Home extends Component {
  goToLogin = () => {
      window.open(routes.login);
  };
  render() {
      const { classes } = this.props;
      return (
          <div style={{ flexGrow: 1 }}>
              <div className={classes.overHeader}>
                  <img src={whiteDots} alt="" className={classes.overHeaderImage} />
              </div>
              <Header
                  transparent
                  help
                  helpCallback={() => window.open(routes.extenal.docs)}
              />
              <VSpacer large />
              <Grid container alignItems="center" direction="column">
                  <Grid item xl={6} md={8}>
                      <Grid container justify="space-between">
                          <Grid item xl={8} md={6}>
                              <Grid
                                  container
                                  alignItems="center"
                                  style={{ minHeight: '400px' }}
                              >
                                  <Grid item>
                                      <Typography variant="h1" className={classes.white}>
                      Optimize your logistic operations with SmartMonkey
                                      </Typography>
                                  </Grid>
                                  <Grid item>
                                      <Typography
                                          variant="h2"
                                          style={{ fontWeight: '400', lineHeight: '125%' }}
                                          className={classes.white}
                                      >
                      Improve the efficency of your routes with SmartMonkey API
                                      </Typography>
                                  </Grid>
                              </Grid>
                          </Grid>
                          <Hidden smDown>
                              <Grid item>
                                  <Grid container>
                                      <Grid item>
                                          <Paper
                                              style={{
                                                  width: '300px',
                                                  height: '400px',
                                                  overflow: 'hidden'
                                              }}
                                          >
                                              {/* <div style={{ position: 'absolute', zIndex: '0', overflow: 'hidden' }}>
                                                    <Animation
                                                        animation={'map_orange_poi'}
                                                        style={{ opacity: '0.2' }}
                                                        width={280}
                                                        height={440}
                                                    />
                                                </div> */}
                                              <div style={{ padding: '20px' }}>
                                                  <Typography variant="h4">Register now!</Typography>
                                                  <RegisterContainer clear />
                                              </div>
                                          </Paper>
                                      </Grid>
                                  </Grid>
                              </Grid>
                          </Hidden>
                      </Grid>
                  </Grid>
                  <VSpacer large />
                  <Grid item xl={6} md={8}>
                      <Grid container component={Paper}>
                          <Grid
                              container
                              style={{
                                  backgroundImage: `url(${rutaPickup})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  borderRadius: '25px 25px 0 0',
                                  minHeight: '300px'
                              }}
                          >
                              <Grid item lg={6} md={6} sm={false} />
                              <Grid
                                  item
                                  md={6}
                                  sm={12}
                                  style={{ padding: '32px', width: 'auto' }}
                              >
                                  <Typography variant="h2">
                    Last mile route optimizer
                                  </Typography>
                                  <VSpacer />
                                  <Typography variant="h5">
                    Our unique architecture automatically allocates the
                    necessary resources to provide the response as fast as
                    possible.
                                  </Typography>
                                  <VSpacer />
                                  <Typography variant="h5">
                    Get your routes optimized in seconds.
                                  </Typography>
                                  <VSpacer />
                              </Grid>
                          </Grid>
                          <Grid container style={{ padding: '32px' }}>
                              <Grid item md={4} sm={6} xs={12}>
                                  <Grid container direction={'row'}>
                                      <ProductFeature
                                          image={landing01}
                                          imageText={'Superfast optimization'}
                                          keypoints={[
                                              'Multiple routes',
                                              'Multiple origins / destinations'
                                          ]}
                                      />
                                  </Grid>
                              </Grid>
                              <Grid item md={4} sm={6} xs={12}>
                                  <Grid container direction={'row'}>
                                      <ProductFeature
                                          image={landing02}
                                          imageText={'Add multiple constraints'}
                                          keypoints={[
                                              'Pickup & delivery',
                                              'Multiple time windows ',
                                              'Multiple vehicle capacities',
                                              'Non mandatory delivery points'
                                          ]}
                                      />
                                  </Grid>
                              </Grid>
                              <Grid item md={4} sm={6} xs={12}>
                                  <Grid container direction={'row'}>
                                      <ProductFeature
                                          image={landing03}
                                          imageText={'Resource management'}
                                          keypoints={[
                                              'Assign vehicles and workers to tasks',
                                              'Incentive management'
                                          ]}
                                      />
                                  </Grid>
                              </Grid>
                          </Grid>
                      </Grid>
                      <VSpacer />
                      {/* <PlansTable /> */}
                  </Grid>
              </Grid>
              <VSpacer />
          </div>
      );
  }
}

export default withStyles(styles)(Home);
